import { Col, Row } from "antd";
import "./Footer.scss";
import { RiTwitterXLine } from "react-icons/ri";
import { BsInstagram } from "react-icons/bs";
import { RiTiktokLine } from "react-icons/ri";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-wrapper">
            <Row gutter={[20, 20]}>
              <Col xxl={6} xl={6}>
                <div className="footer-content">
                  <div className="footer-title">Depop</div>
                  <div className="footer-item">Về chúng tôi</div>
                  <div className="footer-item">Sự nghiệp</div>
                  <div className="footer-item">Blog</div>
                  <div className="footer-item">Tin tức</div>
                  <div className="footer-item">Tác động</div>
                </div>
              </Col>

              <Col xxl={6} xl={6}>
                <div className="footer-content">
                  <div className="footer-title">Bán</div>
                  <div className="footer-item">Bán trên Depop</div>
                  <div className="footer-item">Depop Amplified</div>
                  <div className="footer-item">Chi nhánh Depop</div>
                  <div className="footer-item">Trở thành người bán</div>
                </div>
              </Col>

              <Col xxl={6} xl={6}>
                <div className="footer-content">
                  <div className="footer-title">Giúp đỡ</div>
                  <div className="footer-item">Trung tâm trợ giúp</div>
                  <div className="footer-item">Trạng thái Depop</div>
                </div>
              </Col>

              <Col xxl={6} xl={6}>
                <div className="footer-last-content">
                  <div className="footer-title">Tải ứng dụng Depop</div>

                  <div className="footer-last">
                    <div className="footer-last-img">
                      <img
                        src="https://assets.depop.com/web/assets/get-the-app-qr-code.svg"
                        alt="Image QR"
                      />
                    </div>
                    <div className="footer-last-item">
                      Đăng tin nhanh hơn, theo dõi đơn hàng và không bao giờ bỏ
                      lỡ bất kỳ thông tin nào. Trên iOS và Android.
                    </div>
                  </div>

                  <div className="footer-last-icon">
                    <Link to="https://x.com/askdepop/" target="_blank">
                      <RiTwitterXLine className="last-icon" />
                    </Link>

                    <Link
                      to="https://www.instagram.com/accounts/login/?next=%2Fdepop%2F&source=omni_redirect"
                      target="_blank"
                    >
                      <BsInstagram className="last-icon" />
                    </Link>

                    <Link to="https://www.tiktok.com/@depop" target="_blank">
                      <RiTiktokLine className="last-icon" />
                    </Link>
                  </div>

                  <Link
                    to="https://nguyenhien171.github.io/GrPortfolio/"
                    target="_blank"
                    className="link-nhom"
                  >
                    Link nhóm
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
